<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>MIS Report ME</strong>
               
          </div>       
          <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-row>           
             <!--  <b-col sm="4">
               

              
                           
           
                    <b-form-group label="Delivery Agent"  label-size="sm"
                      :label-cols="3" >                   
                      <v-select id="mySelect" v-model="deliveryagentid" :options="this.data1"  name="deliveryagentid" v-validate="'required'" :class="{ danger: errors.has('deliveryagentid') }">
                      </v-select>
                      <span v-show="errors.has('deliveryagentid')" class="danger">
                          {{ errors.first('deliveryagentid') }}
                      </span>    
                    </b-form-group>  

              </b-col> -->

             

             <!--  <b-col sm="4">
                <b-form-group label="Pickup Type"  :label-cols="4" >
                  <b-form-select  name="Pickup" v-model="Pickup" class="mySelectBox" v-validate="'required'" >
                    <option :value="selected">-Selected Pickup Type-</option>
                    <option value="vendor">Vendor</option>
                    <option value="warehouse">Ware House</option>
                     <option value="3PL">3PL</option>
                  </b-form-select>                                
                </b-form-group>                   
              </b-col> -->


              
              
             
              <b-col sm="4">
                <b-col sm="12" >
                <b-form-group label="Delivery Status:" 
                 label-size="sm"
                :label-cols="4">
                  <b-form-select v-model="shipmentstatus" name="shipmentstatus" class="mySelectBox" v-validate="'required'" :onclick="status()">
                    <option :value="selected">--Selected Status-</option>
                
                    <option value="totaldelivered">Total Delivered</option>
                    <option value="ofd">Total OFD</option>
                    <option value="NDR">Total NDR</option>
                    <option value="totalrto">Total RTO</option>
                    <option value="failedpickup">Total Failed</option>
                    <option value="inscan">Total Inscan</option>
                    <option value="notattempted">Not Attempted</option>
                   <option value="notassigned">Not Assigned</option>
                    <option value="rintransit"> Reverse Intransit</option>
                    <option value="rinscan">Reverse Inscan</option>


                  </b-form-select>                                
                </b-form-group>  
                </b-col>                 
              </b-col>
                   <b-col sm="4" >
                <b-form-group label="Country Code:" label-size="sm" :label-cols="4" >
                  <b-form-select v-model="countrycode" name="countrycode" class="mySelectBox" v-validate="'required'" >
                    <option :value="selected">--Selected type--</option>
                    <option value="OMN">OMN</option>
                    <option value="BHR">BHR</option>  
                     <option value="KWT">KWT</option> 
                    <!--  <option value="SDD&Istrybuy">SDD & Istrybuy </option>
                    <option value="NDD&Istrybuy">NDD & Istrybuy</option>   -->              
                  </b-form-select>  

                    </b-form-group>  
                    </b-col> 
                      <b-col sm="4" >
                         <b-form-group label="ME Zone:" label-size="sm" :label-cols="4" >
                 <b-form-select class="form-control input" v-model="mezoneid" name="mezoneid" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="mezone in mezonelist" v-bind:value="mezone.mezone_id">{{ mezone.mezone_name}}</option>
                  </b-form-select>
               </b-form-group>
                      </b-col>
                             
            </b-row>
                 <b-row>
            <b-col sm="4">
               <b-col sm="12">
                <b-form-group label="Pallet:" label-size="sm" :label-cols="4" >
                   <b-form-select class="form-control input" v-model="palletid" name="palletid" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="pallet in linehaulpalletlist" v-bind:value="pallet.pallet_id">{{ pallet.pallet_title}}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>       
              </b-col>
               <!-- label-size="sm" -->
               <b-col sm="4">
                <b-form-group label="Master AWB:" label-size="sm" :label-cols="4" >
                   <b-form-select class="form-control input" v-model="masterawbno" name="masterawbno" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="awb in masterawbdata" v-bind:value="awb.master_awb">{{ awb.master_awb}}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>

            </b-row> 
            <b-row>
            <b-col sm="4">
               <b-col sm="12">
                <b-form-group label="From Date:"  label-size="sm"
                :label-cols="4">
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              </b-col>       
              </b-col>
              <b-col sm="4">
                <b-form-group label="To Date:" label-size="sm" :label-cols="4" >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>

            </b-row> 
          <b-row>
             <b-col md="4" class="my-1">
              <b-col sm="12" >
                <b-form-group >
                  
                    <b-form-input v-model="searching" placeholder="Type to Search"></b-form-input>
                   
                     
                </b-form-group>
              </b-col>
              </b-col>   
         
              <b-col sm="4">
                <b-form-group>
                 <b-button type="submit" size="md" variant="primary" @click="showCSV(1)"> Search</b-button>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <b-button type="submit" size="md" variant="primary" @click="clear()" style="margin-left: 10%"> clear</b-button>
                 &nbsp;&nbsp;&nbsp;
                 
                </b-form-group>
              </b-col>

              
             <div id="overlay" >
             <div class="loader"></div>
           </div>
           
             
               <b-col sm="4" class="text-right  " >
                <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b>   &nbsp;&nbsp;&nbsp;
                <b-button type="submit" variant="primary" size="md" @click="downloadCSV">Download </b-button>
              </b-col>
            </b-row> 
          </b-form>         
        
          <!--   <b-row class="mb-4">           
              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                  <b-input-group>
                    <b-form-select v-model="sortBy" :options="sortOptions">
                      <option slot="first" :value="null">-- none --</option>
                    </b-form-select>
                    <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                      <option :value="false">Asc</option> <option :value="true">Desc</option>
                    </b-form-select>
                  </b-input-group>
                </b-form-group>
              </b-col>             
              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                  <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col>            
            </b-row>  -->
            <b-col sm="12" >
            <div style="float: left;" v-if="this.totalRows > 0">
               <span class="badge badge-danger" >CPCR</span> Indicates Client Pick Cancel Requested
             </div>  
           </b-col>
           <b-col sm="12" style="overflow:auto">
            <b-table show-empty stacked="md" :busy="isBusy"   :items="items" :fields="fields"  :current-page="currentPage"  :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  @filtered="onFiltered" :bordered="bordered"  > 
                
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

                 <template slot="packagevalue" slot-scope="row">
                {{ (row.item.packagevalue && row.item.paymenttype!='prepaid') ? row.item.packagevalue:'0' }}
                </template>
                  <template slot="orderid" slot-scope="row">
                <span class="badge badge-danger" v-if="row.item.is_mark_ofd == 2" >CPCR</span>
                  {{row.item.orderid}}
                </template> 
                 <template slot="orderid" slot-scope="row">
                  <div style="width:120px">
                  {{row.item.orderid}}
                  </div>
                 </template>
                  <template slot="master_awb" slot-scope="row">
                  <div style="width:75px">
                  {{row.item.master_awb}}
                </div>
                 </template>

               <template slot="pallet_title" slot-scope="row">
                <div style="width:70px">
                  {{row.item.pallet_title}}
                </div>
               </template> 
            <template slot="show_details" slot-scope="row">
                <!-- <b-button v-if="row.item.logdata.length >0" size="sm" @click="info(row.item.logdata,row.item.awbno, row.index, $event.target)" class="mr-1 btn btn-info btn-block active">
                       Log
            </b-button>
            <br/> -->
         
                 
              <b-button size="sm" @click="row.toggleDetails(); MisReportdetails(row.item.awbno,row.detailsShowing); " class="mr-1" style="background: #b0c4de !important;color: #000 !important;">
                {{ row.detailsShowing ? 'Hide' : 'Show'}} 
              </b-button>

            
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card>
                <b-row v-if="details.length >0">
                  <b-col sm="6">
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Order id:</b></b-col>
                      <b-col>{{ details[0].orderid }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Awb No:</b></b-col>
                      <b-col>{{ details[0].awbno }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>City:</b></b-col>
                      <b-col>{{ details[0].branchcity }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Customer Name:</b></b-col>
                      <b-col>{{ details[0].customername }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Vendor Code:</b></b-col>
                      <b-col v-if="details[0].vendorcode =='fc0001'">ae001</b-col>
                     
                      <b-col  v-else>{{details[0].vendorcode}}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Origin:</b></b-col>
                      <b-col>{{ details[0].origin }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Vendor LocationID:</b></b-col>
                      <b-col>{{ details[0].vendorpincode }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Destination:</b></b-col>
                      <b-col>{{ details[0].destination }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Location ID:</b></b-col>
                      <b-col>{{ details[0].destinationpincode ? details[0].destinationpincode:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivery boy:</b></b-col>
                      <b-col>{{ details[0].deliveryboy ? details[0].deliveryboy:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Mobile Number:</b></b-col>
                      <b-col>{{ details[0].dbmobilenumber ? details[0].dbmobilenumber:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Order Status:</b></b-col>
                      <b-col>{{ details[0].orderstatus ? details[0].orderstatus:'-' }}</b-col>
                    </b-row>
                    
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Payment type:</b></b-col>
                      <b-col>{{ details[0].paymenttype ? details[0].paymenttype:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Package Value:</b></b-col>
                      <b-col>{{ details[0].packagevalue ? details[0].packagevalue:'-' }}</b-col>
                        <!-- <b-col>{{ (details[0].packagevalue && details[0].paymenttype!='prepaid') ? details[0].packagevalue:'0' }}</b-col> -->
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Ccheduled end km:</b></b-col>
                      <b-col>{{ details[0].scheduledendkm ? details[0].scheduledendkm:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Scheduled start km:</b></b-col>
                      <b-col>{{details[0].scheduledstartkm ? details[0].scheduledstartkm:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Total distance km:</b></b-col>
                      <b-col>{{ details[0].totaldistancekm ? details[0].totaldistancekm:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Is Try Buy:</b></b-col>
                      <b-col>{{ (details[0].istrybuy==1) ? 'Yes':'No' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Client Delivery Date:</b></b-col>
                      <b-col>{{ (details[0].clientedd) ? details[0].clientedd:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Vendor Name:</b></b-col>
                      <b-col>{{ details[0].vendor_name ? details[0].vendor_name:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                    <b-col sm="4" class="text-sm-right"><b>Zone Name:</b></b-col>
                      <b-col>{{ details[0].zone_name ? details[0].zone_name:'-' }}</b-col>
                    </b-row>
                  </b-col>  
                  <b-col sm="6">
                   
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>order Creation :</b></b-col>
                      <b-col>{{ details[0].ordercreationtimestamp ? details[0].ordercreationtimestamp:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Pickup Check Intime:</b></b-col>
                      <b-col>{{ details[0].pickupcheckintime ? details[0].pickupcheckintime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Order Confirmed Time:</b></b-col>
                      <b-col>{{ details[0].orderconfirmedtime ? details[0].orderconfirmedtime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Pickup Time:</b></b-col>
                      <b-col>{{ details[0].pickuptime ? details[0].pickuptime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Pickup Type:</b></b-col>
                      <b-col>{{ details[0].pickuptype ? details[0].pickuptype:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivery check intime:</b></b-col>
                      <b-col>{{ details[0].deliverycheckintime ? details[0].deliverycheckintime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivery Time:</b></b-col>
                      <b-col>{{ details[0].deliverytime ? details[0].deliverytime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Scheduled Start Time:</b></b-col>
                      <b-col>{{ details[0].scheduledstarttime ? details[0].scheduledstarttime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Scheduled End Time:</b></b-col>
                      <b-col>{{ details[0].scheduledendtime ? details[0].scheduledendtime:'-' }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Total Time Consumed:</b></b-col>
                      <b-col>{{ details[0].totaltimeconsumed ? details[0].totaltimeconsumed:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Order Oreation Medium:</b></b-col>
                      <b-col>{{ details[0].orderoreationmedium ? details[0].orderoreationmedium:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivered By:</b></b-col>
                      <b-col>{{ details[0].deliveredby ? details[0].deliveredby:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Cancelled By:</b></b-col>
                      <b-col>{{ details[0].cancelledby ? details[0].cancelledby:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivery Notes:</b></b-col>
                      <b-col>{{ details[0].deliverynotes ? details[0].deliverynotes:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>NDR Reason:</b></b-col>
                      <b-col>{{ details[0].ndrreason ? details[0].ndrreason:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>NPR Reason:</b></b-col>
                      <b-col>{{ details[0].nprreason ? details[0].nprreason:'-' }}</b-col>
                    </b-row>
                   <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Ship lat long:</b></b-col>
                      <b-col>{{ details[0].shiplonglat ? details[0].shiplonglat:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Pick lat long:</b></b-col>
                      <b-col>{{ details[0].pickuplonglat ? details[0].pickuplonglat:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Vendor Address:</b></b-col>
                      <b-col>{{ details[0].vendor_address ? details[0].vendor_address:'-' }}</b-col>

                       
                    </b-row>

                  
                  </b-col> 
                  <b-col sm="12">
                  <div slot="footer" class="text-right">
                   <b-button size="sm" @click="row.toggleDetails" style="background: #b0c4de !important;color: #000 !important;">Hide Details</b-button>
                  </div> 
                 </b-col> 
                </b-row> 

              </b-card>
            </template>

          </b-table>
        </b-col>
          <b-col md="6" class="my-1" v-if="totalRows>0">
                        <paginate
   
    :page-count="noofpages"
    :page-range="10"
    :margin-pages="2"
    :click-handler="clickCallback"
    :prev-text="'Prev'"
    :next-text="'Next'"
    :container-class="'pagination'"
    :page-class="'page-item'">
  </paginate>
          </b-col>
        </b-card>
      </b-col>
    </b-row>    
      <!-- <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
         <b-row v-if="progressbar.length >0">
          <b-col sm="6" md="4" v-for="(value, firstIndex) in progressbar">
            <div class="card ">
               <div class="card-header bg-primary">
                  <div>Step - {{ firstIndex+1 }}</div>
               </div>
               <div class="card-body bg-secondary" >
                <b>{{ value.process}}</b>
                <br/> <br/>
                <h6>{{ value.comments}}</h6>
               </div>
                <div class="card-footer" style="display:none;">
                </div>
            </div>
          </b-col>  
        </b-row>
      </b-modal>  -->
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue'
export default {
  data: function() {
    return {
      data: [], 
      items:[],
      mezonelist:[],
      linehaulpalletlist:[], 
      masterawbdata:[], 
      selected:'',
      isBusy: false, 
      masterawbno:'', 
      mezoneid:'',
      palletid:'',
      orderflow:'',
      Pickup:'',
      email:'',
      shipmenttype:'',
      countrycode:'',
      shipmentstatus:'',
      hubid:'',
      data1:[],
      // perPage:  10,
      pageNum:1,
      noofpages:'',
      pageOptions: [5, 10, 15],
      sortBy: true,
   
      awbno:'',
      deliveryagentid:'',
      agentmaster: [],
      showdata: [],
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
      hubdata:[],
      details:[],
      progressbar:[],
      orderid:[],
     
      fields: [
    
         // {key: 'orderdate', label: 'Order Date', sortable: true, sortDirection: 'desc' },
          { key: 'orderid', label:'Order Id',sortable: true,sortDirection:'desc'},
          { key: 'awbno', label: 'AWB-Number', sortable: true},
          { key: 'countrycode', label: 'Country Code', sortable: true},
          { key: 'current_hub_country', label: 'Hub Country', sortable: true},
          { key: 'mezone_name', label: 'Zone Name', sortable: true},
          { key: 'pallet_title', label: 'Pallet Name', sortable: true},
          { key: 'master_awb', label: 'Master AWB', sortable: true},
          // { key: 'customername', label: 'Customer Name', sortable: true},
          // { key: 'vendoraddress', label: 'Pick Up Address', sortable: true,tdClass: 'nameOfTheClass'},          
          // { key: 'destination', label: 'Destination Address', sortable: true ,tdClass: 'nameOfTheClass'},  
          
          { key: 'shipmentstatus', label: 'Shipment Status', sortable: true },
          { key: 'orderstatus', label: 'Delivery status', sortable: true },
          // { key: 'paymenttype', label: 'Payment Type' , sortable: true},
           // { key: 'pickuptype', label: 'Pickup Type' , sortable: true},
          { key: 'show_details', label: 'Action',tdClass: 'nameOfTheClass'},
         

        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  20,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        searching:'',
        awbno:'',
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
    };
  },
  computed: {
    // sortOptions() {
    //     // Create an options list from our fields
    //     return this.fields
    //       .filter(f => f.sortable)
    //       .map(f => {
    //         return { text: f.label, value: f.key }
    //       })
    //   }
  },
  created: function() {
   
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.email=userInfo.sysemailid;
     
    this.hubid=userInfo.pickuplocationmasterid.toString();
   
    this.displayHubdata();
    this.displaydeliveryagent();
    this.showCSV(this.pageNum);
    this.displaymezone();
    this.displaylinehaultpallet();
    this.getmasterawblisting();


  },
  methods: {
    info(item, shipmentid,index, button) {
      
      this.progressbar  = item;
      this.infoModal.title = 'Shipment Log - '+shipmentid;
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    validateForm(scope) {},
    trybuyaddawb:function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // alert(userInfo.pickuplocationmasterid);

      const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
       
      };
       this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getmisreportadvancedforME`,obj)
        .then(result => {
          if (result.data.returnmsg == "successful") {

            this.getDownloadCsvObject(result.data.returnvalue);
          
           alert('MIS Report Downloaded Successfully');
            // this.$fire({
            //       text:"MIS Report Downloaded Successfully",
            //       type: "success",
            //       timer: 30000
            //     }); 
            //document.getElementById("loader").style.display = 'none';
          } else {
             alert(result.body.returnmsg);
           // this.$fire({
           //        text:result.body.returnmsg,
           //        type: "error",
           //        timer: 30000
           //      }); 
      
          }
        }).catch(ex => {
          console.log("error-----", ex);
        });
     }, 
    getDownloadCsvObject: function(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear(); var ce
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "MISReport_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    downloadCSV: function() {
      // alert("inn");
       document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var email=this.email;
      var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
      var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      var orderflow=(this.orderflow!=null)? this.orderflow:"";
      var Pickup=(this.Pickup!=null)? this.Pickup:"";
      var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
      var shipmenttype=(this.shipmenttype!=null)? this.shipmenttype:"";
       var countrycode=(this.countrycode!=null)? this.countrycode:"";
      
      var deliveryagentid=(this.deliveryagentid.key!=null)? this.deliveryagentid.key:"";
     
       if(shipmentstatus==="notassigned")
        {

         var csvObj = {
             shipmentstatus:shipmentstatus,
             sysusermasterid:`${userInfo.sysusermasterid}`, 
              hub_id:`${userInfo.pickuplocationmasterid}`,
              // countrycode:countrycode,
             // page_no:1,
           };

        }
        else if(this.searching)
        {
          var csvObj = {
             fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            serviceid: `${this.hubid}`,
            orderflow:orderflow,
            Pickup:Pickup,
            shipmentstatus:shipmentstatus,
            shipmenttype:shipmenttype,
            deliveryagentid:this.deliveryagentid.key,
            shippingid:'',
            email:`${this.email}`,
            search_text:this.searching,
            sysusermasterid:`${userInfo.sysusermasterid}`, 
             hub_id:`${userInfo.pickuplocationmasterid}`,
             // countrycode:countrycode,
              // countrycode:`${userInfo.countrycode}`
             // page_no:1,
           };
         
        }
        else{
          if(this.deliveryagentid.key==undefined)
          {
          var   deliveryagentid="";
          }
          else
          {
           var  deliveryagentid=this.deliveryagentid.key;
          }
          var csvObj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            serviceid: `${this.hubid}`,
            orderflow:orderflow,
            Pickup:Pickup,
            shipmentstatus:shipmentstatus,
            shipmenttype:shipmenttype,
            deliveryagentid:deliveryagentid,
            shippingid:'',
            email:`${this.email}`,
            sysusermasterid:`${userInfo.sysusermasterid}`,
             hub_id:`${userInfo.pickuplocationmasterid}`,
             // countrycode:countrycode,
              // countrycode:`${userInfo.countrycode}`
            // page_no:1,

          };
         
        }
 

      //console.log(csvObj);
      
        // var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
      if(formatdateto< fromdate){
        alert('To date need to be grater than From date');
            // this.$fire({
            //       text:"To date need to be grater than From date",
            //       type: "warning",
            //       timer: 30000
            //     }); 
      }
      //var r = Math.random().toString(36).substring(3); getmisreportcsv_advanced getmisreportcsv_advancedforME
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getmisreportcsv_advancedforME`,csvObj)
        .then(result => {
          document.getElementById("overlay").style.display = "none";
           if(result.body=="success")
         {
         alert("Please Check Ur Mail For Downlod Link")
         // this.$fire({
         //          text:"Please Check Ur Mail For Downlod Link",
         //          type: "success",
         //          timer: 30000
         //        });
       }
       else
       {
        alert("Can not Download");
         // this.$fire({
         //          text:"Can not Download",
         //          type: "error",
         //          timer: 30000
         //        });
       }
         // console.log(result.url);
       // window.location.href =result.url;
        });
        
    },

//     downloadCSV: function() {
//       var email=this.email;
//       var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
//       var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
//       var orderflow=(this.orderflow!=null)? this.orderflow:"";
//       var Pickup=(this.Pickup!=null)? this.Pickup:"";
//       var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
//       var shipmenttype=(this.shipmenttype!=null)? this.shipmenttype:"";
//       // var deliveryagentid=(this.deliveryagentid.key!=null)? this.deliveryagentid.key:"";
     
//        if(shipmentstatus=="notassigned")
//         {

//          var csvObj = {
//              shipmentstatus:shipmentstatus,
//              // page_no:1,
//            };

//         }
//         else if(this.searching)
//         {
//           var csvObj = {
//              fromdate: `${fromdate}`,
//             todate:`${formatdateto}`,
//             serviceid: `${this.hubid}`,
//             orderflow:orderflow,
//             Pickup:Pickup,
//             shipmentstatus:shipmentstatus,
//             shipmenttype:shipmenttype,
//             deliveryagentid:this.deliveryagentid.key,
//             shippingid:'',
//             email:`${this.email}`,
//             search_text:this.searching,
//              // page_no:1,
//            };
         
//         }
//         else{
//           if(this.deliveryagentid.key==undefined)
//           {
//           var   deliveryagentid="";
//           }
//           else
//           {
//            var  deliveryagentid=this.deliveryagentid.key;
//           }
//           var csvObj = {
//             fromdate: `${fromdate}`,
//             todate:`${formatdateto}`,
//             serviceid: `${this.hubid}`,
//             orderflow:orderflow,
//             Pickup:Pickup,
//             shipmentstatus:shipmentstatus,
//             shipmenttype:shipmenttype,
//             deliveryagentid:deliveryagentid,
//             shippingid:'',
//             email:`${this.email}`,
//             // page_no:1,

//           };
         
//         }
 

//       //console.log(csvObj);
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// // console.log(queryString);
//       if(formatdateto< fromdate){
//         alert('To date need to be grater than From date');
          
//       }
//       //var r = Math.random().toString(36).substring(3);
//       this.$http
//         .get(`${CONSTANTS.MIGRATION_API_URL}/getmisreportcsvadvanced`+queryString)
//         .then(result => {
//          // console.log(result.url);
//         window.location.href =result.url;
//         });
        
//     },


  clickCallback (pageNum)
       {
      //   alert(" i m in pagination task");
      // alert(pageNum)
      this.showCSV(pageNum);
    },
     showCSV: function(pagee) {
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
     // alert(pagee);
     
       this.isBusy = true;
      // console.log('test '+this.orderflow);
      //  document.getElementById("loader").style.display = 'block'
      var center = this.hubid;
      if(center == undefined){
        alert('Please select center'); 
        // this.$fire({
        //           text:"Please Select Center",
        //           type: "warning",
        //           timer: 30000
        //         });

        
      }else{
        var email=this.email;
        var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
        // var orderflow=(this.orderflow!=null && this.orderflow!='')? this.orderflow:"both";
         // var Pickup=(this.Pickup!=null && this.Pickup!='')? this.Pickup:"";
         var mezoneid=(this.mezoneid!=null)? this.mezoneid:"";
         var palletid=(this.palletid!=null)? this.palletid:"";
         var masterawbno=(this.masterawbno!=null)? this.masterawbno:"";
        var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
        // var shipmenttype=(this.shipmenttype!=null)? this.shipmenttype:"";
        var countrycode=(this.countrycode!=null)? this.countrycode:"";
       

        if(shipmentstatus==="notassigned")
        {

         var csvObj = {
             shipmentstatus:shipmentstatus,
             page_no:1,
              hub_id:`${userInfo.pickuplocationmasterid}`,
              countrycode:countrycode,
           };

        }
        else if(this.searching)
        {
          var csvObj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            // serviceid: `${this.hubid}`,
            // orderflow:orderflow,
            // Pickup:Pickup,
            mezone_id:mezoneid,
            linehaulpallet_id:palletid,
            master_awb:masterawbno,
            shipmentstatus:shipmentstatus,
            // shipmenttype:shipmenttype,
            deliveryagentid:this.deliveryagentid.key,
            // shippingid:'',
            email:`${this.email}`,
            //page_no:pagee,
            search_text:this.searching,
             hub_id:`${userInfo.pickuplocationmasterid}`,
              // countrycode:`${userInfo.countrycode}`,
              countrycode:countrycode,
              // modeoftransport:"ROAD",
              // master_awb:"BHR_ROAD_2021-03-30_3",
              // pallet_title:"PalletBHR_ROAD_2021-03-30_1",
              // mezone_name:"BHR_Land",
            
           };
         
        }
        else{

          var csvObj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            // serviceid: `${this.hubid}`,
            // orderflow:orderflow,
            // Pickup:Pickup,
            mezone_id:mezoneid,
            linehaulpallet_id:palletid,
            master_awb:masterawbno,
            shipmentstatus:shipmentstatus,
            // shipmenttype:shipmenttype,
            deliveryagentid:this.deliveryagentid.key,
            // shippingid:'',
            email:`${this.email}`,
            page_no:pagee,
            search_text:this.searching,
             hub_id:`${userInfo.pickuplocationmasterid}`,
              // countrycode:`${userInfo.countrycode}`,
              countrycode:countrycode,
              // modeoftransport:"ROAD",
              // master_awb:"BHR_ROAD_2021-03-30_3",
              // pallet_title:"PalletBHR_ROAD_2021-03-30_1",
              // mezone_name:"BHR_Land",
          };
         
        }
 

        if(formatdateto< fromdate){
           alert('To date need to be grater than From date');       
            // this.$fire({
            //       text:"To date need to be grater than From date",
            //       type: "warning",
            //       timer: 30000
            //     });   
        }

        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmisreportadvancedforME`, csvObj)
          .then(result => {
            // console.log('result',result);
             this.isBusy = !this.isBusy;

          //  document.getElementById("loader").style.display = 'none'
            if (result.body.returnmsg && result.body.returnmsg === 'successful') {
                 // console.log(result.body.returnvalue[0]);
                this.showdata = result.body.returnvalue[0].shippingidlist;
                this.items  = result.body.returnvalue[0].shippingidlist;
               
                this.totalRows = result.body.returnvalue[0].totalrecords;  

           this.noofpages=parseInt(this.totalRows)/20;
           
           this.noofpages=Math.ceil( this.noofpages);        
            }else{
             this.showdata = []
              this.items  = [];
              this.totalRows = 0;               
             
            }
          })
          .catch(ex => {
            console.log("error-----", ex);
          });
      }
    },


    
    status: function() {
     
    if(this.shipmentstatus==="notassigned")
     {

     var csvObj = {
          
          shipmentstatus:"notassigned"
         
        };
        
      }
     },



    
    convertArrayOfObjectsToCSV: function(args) {
       var result, ctr, keys, columnDelimiter, lineDelimiter, data;
       data = args.data || null;
       if (data == null || !data.length) {
         return null; var ce
       }
      

       columnDelimiter = args.columnDelimiter || ",";
       lineDelimiter = args.lineDelimiter || "\n";

       //.slice(0,-4)
       keys = Object.keys(data[0]);
       
       result = "";
       result += keys.join(columnDelimiter);
       result += lineDelimiter;
       data.forEach(function(item) {
       var logdata = item['logdata'];
       var attempt = item['attempt'];
       var allowcheckedin = item['allowcheckedin']

        item['pickupcheckintime'] = null;
        item['pickuptime'] = null;

        item['orderconfirmedtime'] = null;
        item['deliverytime'] = null;
        item['ordercreationtimestamp'] = "'"+item['ordercreationtimestamp'];
        item['scheduledstarttime'] = "'"+item['scheduledstarttime'];
        item['scheduledendtime'] = "'"+item['scheduledendtime'];

         if(logdata!==null){

           logdata.forEach(function(itm){
             let mydate = new Date(itm.createddate);
             let month=mydate.getMonth()+1;
             let createddate="'"+mydate.getFullYear()+"-"+month+"-"+mydate.getDate()+" "+mydate.getHours()+":"+mydate.getMinutes();
             switch(itm.process) {
               case 'BookingDone':
                   if(attempt !== null)
                   {
                       if(attempt == itm.attempt)
                       {
                         item['orderconfirmedtime'] = createddate.toString();
                         break;
                       }
                    }else {
                       item['orderconfirmedtime'] = createddate.toString();
                      break;
                    }
               case 'OFD':
                    if(attempt !== null)
                   {
                       if(attempt == itm.attempt)
                       {
                         if(allowcheckedin == 'true'){
                           item['pickupcheckintime'] = item['pickupcheckintime1'];
                           item['pickuptime'] = createddate.toString();
                           break;
                         }else {

                           item['pickupcheckintime'] = createddate.toString();
                           item['pickuptime'] = createddate.toString();
                           break;
                         }
                       }
                  }else {
                    if(allowcheckedin == 'true'){
                      item['pickupcheckintime'] = item['pickupcheckintime1'];
                      item['pickuptime'] = createddate.toString();
                      break;
                    }else {
                      item['pickupcheckintime'] = createddate.toString();
                      item['pickuptime'] = createddate.toString();
                      break;
                    }
                  }
               case 'DLV':
                 if(attempt !== null)
                 {
                     if(attempt == itm.attempt)
                     {
                        if(allowcheckedin == 'true'){
                           item['deliverycheckintime'] = item['deliverycheckintime1'];
                           item['deliverytime'] = createddate.toString();
                           break;
                        }else {
                          item['deliverycheckintime'] = createddate.toString();
                          item['deliverytime'] = createddate.toString();
                          break;
                        }
                     }
                }else {
                    if(allowcheckedin == 'true'){
                       item['deliverycheckintime'] = item['deliverycheckintime1'];
                       item['deli var ceverytime'] = createddate.toString();
                       break;
                    }else {
                      item['deliverycheckintime'] = createddate.toString();
                      item['deliverytime'] = createddate.toString();
                      break;
                    }
                }

                case 'NDR':
                  if(attempt !== null)
                  {
                      if(attempt == itm.attempt)
                      {
                        item['deliverycheckintime'] = null;
                        item['deliverytime'] = null;
                        break;
                      }
                 }else {
                        item['deliverycheckintime'] = null;
                        item['deliverytime'] = null;
                     break;
                 }
             }
           });
         } else {
           item['deliverytime'] = '';
           item['orderconfirmedtime'] = '';
           item['pickupcheckintime'] = '';
           item['pickuptime'] = '';
         }
         ctr = 0;
        

         keys.forEach(function(key) {
          // console.log('--------------------');
          // console.log(key);
              //       console.log('-----datta---------------');
//&& key!='logdata'
           if (ctr > 0) result += columnDelimiter;
           if (item[key] != null && key!='logdata') {

            if(key=='origin'){
                var str2=item[key];
                str2=str2.replace('#','');
                result += '"' +str2 + '"';
             }else{
             result += '"' + item[key] + '"';
             }      
           }           
           
           ctr++;
         });
         result += lineDelimiter;
       });
     //  document.getElementById("loader").style.display = 'none';

       return result;
     },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    },
      clear: function() {
   this.searching="";
   this.deliveryagentid="";
   // this.Pickup="";
   this.shipmentstatus="";
   // this.shipmenttype="";
   this.countrycode="";
   // this.selectDateFrom="";
   // this.selectDateTo="";
    this.filter="";
    this.showCSV(this.pageNum);
   
   
      
    },
   
    displayHubdata: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

      const deliveryagentobj = {
        // hub_id:`${userInfo.pickuplocationmasterid}`,
      }
      this.$http.post(`${CONSTANTS.API_URL}/P2PReports/GetAllHubListMaster`,deliveryagentobj)
        .then(result => {
          this.hubdata = result.body.returnvalue;
          // console.log("Hublist",this.hubdata);
        })
        .catch(ex => {
          console.log('error-----', ex)
        });
    },




    MisReportdetails: function(shipmentid,showhide) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
        var showhides=showhide;
      
 if(showhides)
 {

 }
 else{
      
 
 var awbno = shipmentid;
 //alert(awbno)

  var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";

       
        var shippingidobj = {
          fromdate: `${fromdate}`,
          todate:`${formatdateto}`,
          serviceid: `${this.hubid}`,
          shippingid: `${awbno}`,
          hub_id:`${userInfo.pickuplocationmasterid}`,
        };

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmisreportdetails`,shippingidobj)
        .then(result => {
          this.details = result.body.returnvalue;
          //console.log(this.details);
        })
        .catch(ex => {
          console.log('error-----', ex)
        });
      }
    },

    //Function for mezonemanagement

        displaymezone: function () {
      // alert("getlinehaulpalletlisting");
    this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

       const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
      
      };
      

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmezonelist`,obj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
             this.mezonelist  = result.body.returnvalue;
             // console.log("hhhhh",this.mezonelist);
             // this.items=[];
             // this.totalRows =0;
            
          } else {
            this.mezonelist=result.body.returnvalue;
           
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
       
       //End
        
        // Function for LineHault Pallet
          displaylinehaultpallet: function () {
      // alert("getlinehaulpalletlisting");
    this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

       const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
      
      };
      

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getlinehaulpalletlisting`,obj)
        .then((result) => {
          // console.log("display",result);
          if (result.body.returnmsg === 'Successful') {
             this.linehaulpalletlist  = result.body.returnvalue;
             // console.log("displaydata",this.items);
             // console.log(this.items);
             // this.items=[];
             // this.totalRows =0;
             
          } else {
            this.linehaulpalletlist=[];
           
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },

      // End
       //function for Master Awb listing
    getmasterawblisting:function() {
        var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    const Obj_listing = {
            hub_id:`${userInfo.pickuplocationmasterid}`,
                }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getmasterawblist`,Obj_listing)
            .then((result) => {
           
           // console.log( result.body);
             
              if (result.body.returnmsg =="Successful") {
                 // document.getElementById("overlay").style.display = "none";
                this.masterawbdata = result.body.returnvalue;
                 
                  // console.log("masterawbdata", this.masterawbdata);
              } 
              else {
                //alert('Result not found')
                this.masterawbdata = [];
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
      
    },

    displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
         hub_id:`${userInfo.pickuplocationmasterid}`,
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          // this.agentmaster = result.body
          this.data1 = result.body
           var data = [];
 
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.deliveryagentmasterid,
                  label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
                });
              });
              this.data1 = data;
          
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    }

  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
  padding: .2rem!important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}
  .nameOfTheClass {
   max-width: 450px !important;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/*tbody tr:nth-child(odd) {
    background: darkgray !important;
}*/
</style>
